import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import ENV from "../constants/environment";

const isEnabled = String(ENV.NEW_RELIC_ENABLED).toLowerCase() === "true";

const isConfigured = [
  ENV.NEW_RELIC_ACCOUNT_ID,
  ENV.NEW_RELIC_TRUST_KEY,
  ENV.NEW_RELIC_AGENT_ID,
  ENV.NEW_RELIC_LICENSE_KEY,
  ENV.NEW_RELIC_APPLICATION_ID,
].every(Boolean);

const options: ConstructorParameters<typeof BrowserAgent>[0] = {
  init: {
    browser_consent_mode: { enabled: false },
    privacy: { cookies_enabled: true },
    performance: { capture_measures: true }
  },
  loader_config: {
    accountID: ENV.NEW_RELIC_ACCOUNT_ID,
    trustKey: ENV.NEW_RELIC_TRUST_KEY,
    agentID: ENV.NEW_RELIC_AGENT_ID,
    licenseKey: ENV.NEW_RELIC_LICENSE_KEY,
    applicationID: ENV.NEW_RELIC_APPLICATION_ID,
  },
  info: {
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    licenseKey: ENV.NEW_RELIC_LICENSE_KEY as string,
    applicationID: ENV.NEW_RELIC_APPLICATION_ID as string,
    sa: 1,
  },
};

export const newRelic = isEnabled && isConfigured ? new BrowserAgent(options) : null;